import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { IOrderDetails } from '../../../models/order';
import { ISession } from '../../../models/pro-sites';
import { loadSession } from '../../../store/session/session-actions';
import * as CON from '../../common/constants';
import './order-center.css';
import * as FORM from './ordercenter-items';
import { IOrderCenterItem } from '../../../models/constants';
import { getOrderCenterForm } from '../../../api/order-center-api';
import { apiOpenPDF } from '../../../api/api-utils';

interface IOrderCenterProps {
    order: IOrderDetails;
    session: ISession | null;
    loadSession: () => Promise<void>;
}
export const OrderCenterForms = ({
    order,
    session,
    loadSession,
}: IOrderCenterProps) => {
    const intl = useIntl();
    const englishLanguage = intl.formatMessage({
        id: CON.EN_LANG,
    });
    const [countryCode, setCountryCode] = useState('');
    const [brand, setBrand] = useState('');
    const [language, setLangauage] = useState('');
    const orderCenterForm = FORM.resolveProductForms(countryCode, brand);

    const openOrderCenterForm = async (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        url: string | undefined
    ) => {
        e.preventDefault();
        if (countryCode === CON.DE) {
            window.open(url);
        } else {
            const modifiedURL = FORM.PDFSURL + url;
            const result = await getOrderCenterForm(modifiedURL);
            apiOpenPDF(result);
        }
    };
    useEffect(() => {
        setBrand(session!.selectedBrand);
        if (session!.country === CON.CA) {
            setCountryCode(CON.CA);
            setLangauage(
                intl.formatMessage({
                    id: CON.CA_FR_LANG.split(' ').join('_'),
                    defaultMessage: CON.CA_FR_LANG,
                })
            );
        } else if (session!.country === CON.KR) {
            setCountryCode(CON.KR);
            setLangauage(
                intl.formatMessage({
                    id: CON.KR_LANG,
                    defaultMessage: CON.KR_LANG,
                })
            );
        } else if (session!.country === CON.DE) {
            setCountryCode(CON.DE);
            setLangauage(
                intl.formatMessage({
                    id: CON.DE_LANG,
                    defaultMessage: CON.DE_LANG,
                })
            );
        }
    }, []);
    return (
        <>
            <div className="row">
                <div className="col-sm-8 col-md-9">
                    <h1 className="underline">
                        <span className="lowercase">e</span>Store is here!
                    </h1>

                    <div className="row">
                        <div className="col-sm-7 col-md-8">
                            <p>
                                <FormattedMessage
                                    id="eStore_promo_text"
                                    defaultMessage="Faster estore access.Order Hearing aids online"
                                />
                            </p>
                            <p>
                                <a href="/estore" className="hrefStyle arrow">
                                    <FormattedMessage
                                        id="Start_shopping_in_the_eStore"
                                        defaultMessage="Start shopping in the eStore"
                                    />
                                </a>
                            </p>
                        </div>

                        <div className="col-sm-5 col-md-4">
                            <a href="/estore">
                                <img
                                    className="dashboard-button"
                                    src="/images/buttons/dashboard/estore.png"
                                />
                            </a>
                        </div>
                    </div>
                    <hr className="hrStyle" />
                    <div className="tipdown clearfix">
                        <table className="table gutter-bottom">
                            <caption>
                                <FormattedMessage
                                    id="PRODUCT_FORMS"
                                    defaultMessage="Product Forms"
                                />
                            </caption>
                            <tbody>
                                {orderCenterForm.productForms.map(
                                    (item: IOrderCenterItem) => {
                                        return (
                                            <tr>
                                                <td className="doc-name">
                                                    <FormattedMessage
                                                        id={item.title
                                                            .split(' ')
                                                            .join('_')}
                                                        defaultMessage={
                                                            item.title
                                                        }
                                                    />
                                                </td>

                                                {item.englishPdf && (
                                                    <td className="doc-links">
                                                        <a
                                                            href="#"
                                                            onClick={(e) =>
                                                                openOrderCenterForm(
                                                                    e,
                                                                    item!
                                                                        .englishPdf
                                                                )
                                                            }
                                                            target="_blank"
                                                        >
                                                            {englishLanguage}
                                                        </a>
                                                    </td>
                                                )}

                                                {item.localePdf && (
                                                    <>
                                                        <td>
                                                            <span>|</span>
                                                        </td>
                                                        <td className="doc-links">
                                                            <a
                                                                href="#"
                                                                onClick={(e) =>
                                                                    openOrderCenterForm(
                                                                        e,
                                                                        item.localePdf
                                                                    )
                                                                }
                                                                target="_blank"
                                                            >
                                                                {language}
                                                            </a>
                                                        </td>
                                                    </>
                                                )}
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                        <table className="table table-striped gutter-bottom">
                            <caption>
                                <FormattedMessage
                                    id="EARMOLD_FORMS"
                                    defaultMessage="Earmold Forms"
                                />
                            </caption>
                            <tbody>
                                {orderCenterForm.earmoldForms.map(
                                    (item: IOrderCenterItem) => {
                                        return (
                                            <tr>
                                                <td className="doc-name">
                                                    <FormattedMessage
                                                        id={item.title
                                                            .split(' ')
                                                            .join('_')}
                                                        defaultMessage={
                                                            item.title
                                                        }
                                                    />
                                                </td>
                                                {item.englishPdf && (
                                                    <td className="doc-links">
                                                        <a
                                                            href="#"
                                                            onClick={(e) =>
                                                                openOrderCenterForm(
                                                                    e,
                                                                    item.englishPdf
                                                                )
                                                            }
                                                            target="_blank"
                                                        >
                                                            {englishLanguage}
                                                        </a>
                                                    </td>
                                                )}
                                                {item.localePdf && (
                                                    <>
                                                        <td>
                                                            <span>|</span>
                                                        </td>
                                                        <td className="doc-links">
                                                            <a
                                                                href="#"
                                                                onClick={(e) =>
                                                                    openOrderCenterForm(
                                                                        e,
                                                                        item.localePdf
                                                                    )
                                                                }
                                                                target="_blank"
                                                            >
                                                                {language}
                                                            </a>
                                                        </td>
                                                    </>
                                                )}
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                        <table className="table table-striped gutter-bottom">
                            <caption>
                                <FormattedMessage
                                    id="service/repair/return_forms"
                                    defaultMessage="Service/Repair/Return Forms"
                                />
                            </caption>
                            <tbody>
                                {orderCenterForm.serviceRepairForms.map(
                                    (item: IOrderCenterItem) => {
                                        return (
                                            <tr>
                                                <td className="doc-name">
                                                    <FormattedMessage
                                                        id={item.title
                                                            .split(' ')
                                                            .join('_')}
                                                        defaultMessage={
                                                            item.title
                                                        }
                                                    />
                                                </td>
                                                {item.englishPdf && (
                                                    <td className="doc-links">
                                                        <a
                                                            href="#"
                                                            onClick={(e) =>
                                                                openOrderCenterForm(
                                                                    e,
                                                                    item.englishPdf
                                                                )
                                                            }
                                                            target="_blank"
                                                        >
                                                            {englishLanguage}
                                                        </a>
                                                    </td>
                                                )}
                                                {item.localePdf && (
                                                    <>
                                                        <td>
                                                            <span>|</span>
                                                        </td>
                                                        <td className="doc-links">
                                                            <a
                                                                href="#"
                                                                onClick={(e) =>
                                                                    openOrderCenterForm(
                                                                        e,
                                                                        item.localePdf
                                                                    )
                                                                }
                                                                target="_blank"
                                                            >
                                                                {language}
                                                            </a>
                                                        </td>
                                                    </>
                                                )}
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-4 col-md-3">
                    <hr className="visible-xs" />

                    <div className="highlight">
                        <h3>
                            <FormattedMessage
                                id="Ordering_Made_Easy"
                                defaultMessage="Ordering Made Easy"
                            />
                        </h3>

                        <p>
                            <FormattedMessage
                                id="eStore_is_easy"
                                defaultMessage="'eStore is easy"
                            />
                        </p>
                        <dl className="dlStyle">
                            <dd>
                                <a
                                    href="#"
                                    onClick={(e) =>
                                        openOrderCenterForm(
                                            e,
                                            FORM.ESTORE_INSTRUCTION_URL
                                        )
                                    }
                                    target="_blank"
                                >
                                    <FormattedMessage
                                        id="eStore_Instructions"
                                        defaultMessage="Ordering Made Easy"
                                    />
                                </a>
                            </dd>
                        </dl>
                    </div>

                    <div className="gutter-top">
                        <a href="/my-account/online-forms/receiver-replacement-ordering">
                            <img
                                className="dashboard-button"
                                src="/images/buttons/dashboard/receiver-replacement.png"
                            />
                            <span className="visually-hidden">
                                <FormattedMessage
                                    id="Receiver_Replacement_and_Ordering"
                                    defaultMessage="Receiver Replacement and Ordering"
                                />
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
    };
};

const mapDispatchToProps = {
    loadSession,
};
const orderCenterContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderCenterForms);
export default orderCenterContainer;
